import React from 'react';
import {Card as BsCard} from '@goproblems/ui';

export const Card = ({
    title,
    bodyClassName = 'p-3',
    children,
    ...props
}: {
    title: string;
    bodyClassName?: string;
    children: React.ReactNode;
    [key: string]: any;
}) => {
    return (
        <BsCard {...props}>
            <h6 className="card-header p-menu-entry">
                <span className="capitalize">{title}</span>
            </h6>
            <div className={bodyClassName}>{children}</div>
        </BsCard>
    );
};
